import { addDays, format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { Calendar as CalendarIcon } from 'lucide-react'
import * as React from 'react'
import { DateRange } from 'react-day-picker'

import { cn } from '@/lib/utils'
import { Button } from '@/view/components/ui/button'
import { Calendar } from '@/view/components/ui/calendar'
import { Popover, PopoverContent, PopoverTrigger } from '@/view/components/ui/popover'

interface DatePickerWithRangeProps extends React.HTMLAttributes<HTMLDivElement> {
  setInitDate?: (date: string) => void
  setFinishDate?: (date: string) => void
}

export function DatePickerWithRange({ className, setInitDate, setFinishDate }: DatePickerWithRangeProps) {
  const [date, setDate] = React.useState<DateRange | undefined>({
    from: new Date(),
    to: addDays(new Date(), 30)
  })

  React.useEffect(() => {
    if (date?.from) {
      setInitDate?.(date.from.toISOString())
    }
    if (date?.to) {
      setFinishDate?.(date.to.toISOString())
    }
  }, [date])

  return (
    <div className={cn('grid gap-2', className)}>
      <Popover>
        <PopoverTrigger asChild>
          <Button id="date" variant={'outline'} className={cn('w-full justify-start text-left font-normal', !date && 'text-muted-foreground')}>
            <CalendarIcon className="mr-2 h-4 w-4 text-acelerafit-green-400" />
            {date?.from ? (
              date.to ? (
                <>
                  {format(date.from, 'dd LLL, y', { locale: ptBR })} - {format(date.to, 'dd LLL, y', { locale: ptBR })}
                </>
              ) : (
                format(date.from, 'dd LLL, y')
              )
            ) : (
              <span>Selecione a data</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar initialFocus mode="range" defaultMonth={date?.from} selected={date} onSelect={setDate} numberOfMonths={2} lang="pt" locale={ptBR} />
        </PopoverContent>
      </Popover>
    </div>
  )
}
